import { writable } from "svelte/store";

// tracks whether the search modal is open or not
export const search = writable(false);
